import React from 'react';
import {
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    SimpleForm,
    TextInput,
    SelectInput,
    SelectField,
    NumberInput,
    BooleanInput,
    BooleanField,
    ReferenceInput,
    Filter,
    DateField
} from 'react-admin';

import { required, maxLength, minLength } from './../../utils/validations'

const foodCategoryChoices = [
    { id: 0, name: 'Veg' },
    { id: 1, name: 'Nonveg' }
];

const ProductFilter = (props) => (
    <Filter {...props}>
        <TextInput source="name" label="Name" />
        <BooleanInput source="enabled" label="Enable" />
        <BooleanInput source="recommended" label="Recommended" />
    </Filter>
);

const validateName = [required(), minLength(2), maxLength(60)];

const validateInput = values => {
    const errors = {};
    if (values.actualPrice && values.actualPrice < 0) {
        errors.actualPrice = 'Actual price must not be less than 0';
    }
    if (values.price && values.price < 0) {
        errors.price = 'Actual price must not be less than 0';
    }
    if (values.actualPrice && values.price && values.actualPrice > values.price) {
        errors.actualPrice = 'Actual price should not be more than selling price';
    }
    return errors
}

export const ProductList = (props) => (
    <List {...props} title={`Products`} bulkActionButtons={false}
        filters={<ProductFilter />} sort={{ field: "creationTime", order: "DESC" }}>
        <Datagrid>
            <TextField source="name" label="Name" />
            <TextField source="category.name" label="Category" />
            <TextField source="price" label="Price" />
            <SelectField source="subType"
                choices={foodCategoryChoices}
                label="Type" />
            <BooleanField source="available" label="Available" />
            <BooleanField source="enabled" label="Enable" />
            <DateField source="creationTime" showTime label="Creation Time" />
            <EditButton />
        </Datagrid>
    </List>
);

export const ProductEdit = (props) => {
    const userType = atob(sessionStorage.getItem("zutp"));
    if ((userType === 'SA') || (userType === 'CA')) {
        return (
            <Edit title={`Edit Product`} {...props}>
                <SimpleForm redirect="list" {...props} validate={validateInput}>
                    <TextInput label="Name" source="name" validate={validateName} />
                    <ReferenceInput
                        label="Category"
                        source="categoryId"
                        reference="mrcht/categories"
                        allowEmpty
                        validate={required()}>
                        <SelectInput optionText="name" />
                    </ReferenceInput>
                    <TextInput label="Image URL" source="imageUrl" />
                    <NumberInput label="Actual Price" source="actualPrice" validate={required()} />
                    <NumberInput label="Selling Price" source="price" validate={required()} />
                    <SelectInput
                        source="subType"
                        choices={foodCategoryChoices}
                        label="Type"
                        validate={required()} />

                    <TextInput fullWidth label="Description" source="description" />
                    <BooleanInput source="available" label="Available" />
                    <BooleanInput source="recommended" label="Recommended" />
                    <BooleanInput source="enabled" label="Enable" defaultValue={true} />
                </SimpleForm>
            </Edit>
        );
    }
    return (
        <Edit title={`Edit Product`} {...props} >
            <SimpleForm redirect="list" {...props} validate={validateInput}>
                <TextInput label="Name" source="name" validate={validateName} disabled />
                <ReferenceInput
                    label="Category"
                    source="categoryId"
                    reference="mrcht/categories"
                    disabled
                    allowEmpty
                    validate={required()}>
                    <SelectInput optionText="name" />
                </ReferenceInput>
                <TextInput label="Image URL" source="imageUrl" />
                <NumberInput label="Actual Price" source="actualPrice" validate={required()} disabled />
                <NumberInput label="Selling Price" source="price" validate={required()} disabled />
                <SelectInput
                    source="subType"
                    choices={foodCategoryChoices}
                    label="Type"
                    disabled
                    validate={required()} />
                <TextInput fullWidth label="Description" source="description" />
                <BooleanInput source="available" label="Available" />
                <BooleanInput source="recommended" label="Recommended" />
                <BooleanInput source="enabled" label="Enable" defaultValue={true} />
            </SimpleForm>
        </Edit>
    );
}

export const ProductCreate = (props) => (
    <Create title={`Create Product`} {...props}>
        <SimpleForm redirect="list" validate={validateInput}>
            <TextInput label="Name" source="name" validate={validateName} />
            <ReferenceInput
                label="Category"
                source="categoryId"
                reference="mrcht/categories"
                perPage={100}
                allowEmpty
                validate={required()}>
                <SelectInput optionText="name" />
            </ReferenceInput>
            <TextInput label="Image URL" source="imageUrl" />
            <NumberInput label="Actual Price" source="actualPrice" validate={required()} />
            <NumberInput label="Selling Price" source="price" validate={required()} />
            <SelectInput
                source="subType"
                choices={foodCategoryChoices}
                label="Type"
                allowEmpty
                validate={required()} />
            <TextInput fullWidth label="Description" source="description" />
            <BooleanInput source="available" label="Available" defaultValue={true} />
            <BooleanInput source="recommended" label="Recommended" />
            <BooleanInput source="enabled" label="Enable" defaultValue={true} />
        </SimpleForm>
    </Create>
);
